class DebugModel {
    public currentDebugCase: string;
    public debugData: any;
    public special: boolean

    public cleanUp() {
        this.currentDebugCase = "";
        this.debugData = null;
        this.special = false;
    }
}

export default new DebugModel();
